import React, { useEffect, useState, useRef, useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import LoadingContext from '../../context/Loading/Loading'
import { inviteValid, register, addMember } from '../../utilities/api'
import { namePatternMatch, scrollToTop } from '../../utilities/helpers'

import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'

import { PasswordInput } from '../PasswordInput'
import { Error } from '../Error'
import { SuccessContainer } from '../SuccessContainer'
import { PageLoadingContainer } from '../PageLoadingContainer'
import { Spinner } from '../LoadingContainer/Spinner'

export default function RegisterWrapper({ code }) {
  const navigate = useNavigate()
  const passwordEl = useRef()

  const { showLoading, hideLoading, isLoading } = useContext(LoadingContext)

  const [alert, setAlert] = useState({
    error: false,
    message: '',
  })

  const [invite, setInvite] = useState({
    inviteCode: '',
    organization: {},
    organization_role: {},
  })

  const [complete, setComplete] = useState(false)

  const [credentials, setCredentials] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
  })

  const [isValid, setIsValid] = useState(true)

  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    if (!isValid) setIsValid(true)
  }, [credentials.firstName, credentials.lastName, credentials.password])

  useEffect(() => {
    if (complete) {
      setTimeout(() => {
        navigate('/login')
      }, 2000)
    }
  }, [complete])

  const handleCredentials = (e) => {
    e.target &&
      setCredentials((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  useEffect(() => {
    showLoading()
    inviteValid(code)
      .then((res) => {
        setCredentials((prev) => ({
          ...prev,
          email: res.data.email,
          username: res.data.email,
          firstName: res.data.firstName ?? '',
          lastName: res.data.lastName ?? '',
        }))
        setInvite(res.data)
        hideLoading()
      })
      .catch((err) => {
        scrollToTop()
        hideLoading()
        setAlert({
          error: true,
          message: 'Invalid invite code',
        })
      })
  }, [code])

  const handleValid = () => {
    if (credentials.password !== '' && !passwordEl.current.validity.valid) {
      setIsValid(false)
    }
  }

  const submit = (e) => {
    e.preventDefault()
    if (isValid) {
      setIsSaving(true)
      register(credentials)
        .then((res) => {
          let user = res.data.user
          let data = {
            user,
            invite,
          }
          addMember({ data })
            .then((res) => {
              setComplete(true)
              setIsSaving(false)
            })
            .catch((err) => {
              console.error(err)
              setIsSaving(false)
            })
        })
        .catch((err) => {
          console.error(err)
          setIsSaving(false)
        })
    }
  }

  return (
    <>
      {isLoading ? (
        <PageLoadingContainer style="without-sidebar" />
      ) : (
        <section className="wrapper-xs">
          <>
            {alert && alert.error && (
              <Alert key="danger" variant="danger" className="mb-3">
                {alert?.message}
              </Alert>
            )}
          </>
          {!complete && (
            <>
              <header className="mb-5">
                <h1 className="fs-md">Team Member Registration</h1>
                <h2 className="text-muted normal fw-medium">
                  The future of ticketing is here
                </h2>
              </header>
              <Form onSubmit={submit}>
                <Form.Group className="form-group">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    disabled
                    name="email"
                    required
                    defaultValue={credentials.email}
                  />
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    required
                    placeholder="Enter your first name"
                    pattern={namePatternMatch}
                    value={credentials.firstName}
                    onChange={(e) =>
                      handleCredentials(
                        e.target.validity.valid || e.target.value === ''
                          ? e
                          : credentials.firstName
                      )
                    }
                  />
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    required
                    placeholder="Enter your last name"
                    pattern={namePatternMatch}
                    value={credentials.lastName}
                    onChange={(e) =>
                      handleCredentials(
                        e.target.validity.valid || e.target.value === ''
                          ? e
                          : credentials.lastName
                      )
                    }
                  />
                </Form.Group>
                <Form.Group className="form-group" controlId="password">
                  <Form.Label>Password</Form.Label>
                  <PasswordInput
                    value={credentials.password}
                    reference={passwordEl}
                    isValid={isValid}
                    handlePassword={handleCredentials}
                    onBlur={handleValid}
                  />
                  {!isValid && <Error type="invalidPassword" />}
                </Form.Group>
                <Button
                  type="submit"
                  size="lg"
                  className={`mt-4 w-100 ${!isSaving ? 'btn-next' : ''} `}
                  disabled={
                    !credentials.firstName ||
                    !credentials.lastName ||
                    !credentials.password ||
                    !isValid ||
                    isSaving
                  }
                >
                  {isSaving ? <Spinner /> : 'Submit'}
                </Button>
              </Form>
            </>
          )}
          {complete && (
            <SuccessContainer>
              <h1 className="heading">
                Your account has been successfully created!
              </h1>
              <p className="text-muted fw-medium">Redirecting to login...</p>
            </SuccessContainer>
          )}
        </section>
      )}
    </>
  )
}
